import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as AirportListActions from './Airportlist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class AirportListEffects {
  constructor(
    private actions$: Actions,
    private airportService: NSAdminbuysellRuleserviceService
  ) {}

  loadAirportList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AirportListActions.loadAirportList),
      mergeMap(() =>
        this.airportService.GetAirportlist().pipe(
          map((airports) =>
            AirportListActions.loadAirportListSuccess({ airports })
          ),
          catchError((error) =>
            of(AirportListActions.loadAirportListFailure({ error }))
          )
        )
      )
    )
  );
}
